import {ColumnsType} from "antd/lib/table/interface";
import {Translate} from "../../../hooks/translate.hook";
import {AccountingSummaryItem} from "../../../models/accounting/summary";
import {ExpandableConfig} from "antd/es/table/interface";
import {Price} from "../../common/price/price";
import {Link} from "react-router-dom";

export const columnsFactory = (t: Translate): ColumnsType<AccountingSummaryItem & ExpandableConfig<AccountingSummaryItem>> => {
    return [
        {
            title: t("CLIENT.NUMBER"),
            dataIndex: "agentNumber",
            key: "agentNumber",
            render: value => <Link target={"_blank"} to={"/clients/" + value + "/documents/statements"}>{value}</Link>
        },
        {
            title: t("CLIENT.NAME"),
            dataIndex: "agentName",
            key: "agentName"
        },
        {
            title: "Max overdue days",
            dataIndex: "maxOverdueDays",
            key: "maxOverdueDays",
            sorter: (a, b) => a.maxOverdueDays - b.maxOverdueDays
        },
        {
            title: "Overdue",
            key: "overdue",
            sorter: (a, b) => a.overdueSubtotal - b.overdueSubtotal,
            render: (_: any, item) => {
                return <>
                    <Price value={{value: item.overdueSubtotal, currencyCode: item.currencyCode as any}} />
                    &nbsp;({item.overdueCnt})
                </>
            }
        },
        {
            title: "Awaiting",
            key: "awaiting",
            sorter: (a, b) => a.awaitingSubtotal - b.awaitingSubtotal,
            render: (_: any, item) => {
                return <>
                    <Price value={{value: item.awaitingSubtotal, currencyCode: item.currencyCode as any}} />
                    &nbsp;({item.awaitingCnt})
                </>
            }
        },
        {
            title: "Overpaid",
            key: "overpaid",
            sorter: (a, b) => a.overpaidSubtotal - b.overpaidSubtotal,
            render: (_: any, item) => {
                return <>
                    <Price value={{value: item.overpaidSubtotal, currencyCode: item.currencyCode as any}} />
                    &nbsp;({item.overpaidCnt})
                </>
            }
        },
        {
            title: "Free balance",
            dataIndex: "freeBalance",
            key: "freeBalance",
            sorter: (a, b) => a.freeBalance - b.freeBalance,
            render: (_: any, item) => {
                return <>
                    <Price value={{value: item.freeBalance, currencyCode: item.currencyCode as any}} />
                </>
            }
        },
        {
            title: "Invoices balance",
            dataIndex: "invoicesBalance",
            key: "invoicesBalance",
            sorter: (a, b) => a.invoicesBalance - b.invoicesBalance,
            render: (_: any, item) => {
                return <>
                    <Price value={{value: item.invoicesBalance, currencyCode: item.currencyCode as any}} />
                </>
            }
        },
        {
            title: "Credit Invoices balance",
            dataIndex: "creditInvoicesBalance",
            key: "creditInvoicesBalance",
            sorter: (a, b) => a.creditInvoicesBalance - b.creditInvoicesBalance,
            render: (_: any, item) => {
                return <>
                    <Price value={{value: item.creditInvoicesBalance, currencyCode: item.currencyCode as any}} />
                </>
            }
        },
        {
            title: "Total balance",
            dataIndex: "balance",
            key: "balance",
            sorter: (a, b) => a.balance - b.balance,
            render: (_: any, item) => {
                return <>
                    <Price value={{value: item.balance, currencyCode: item.currencyCode as any}} />
                </>
            }
        },
    ];
}